var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState } from "react";
import { createUseStyles, ThemeProvider, useTheme } from "react-jss";
import { useNavigate } from "react-router-dom";
import { getInputValue } from "../utils";
import { EngageContext, ErrorType } from "../context";
import { EngageMessageType } from "engage-common/messages";
import AppBar from "../components/AppBar";
import DisplayText, { TextVariant } from "../components/DisplayText";
import TextField from "../components/TextField";
import { AlternateHostName } from "engage-common/constants";
import { ConfigContext } from "../index";
import Button from "../components/Button";
import Checkbox from "../components/Checkbox";
import CreateTeams from "../components/teams/CreateTeams";
import { TeamMode } from "engage-common/types";
import AddTeamIcon from "../components/icons/AddTeamIcon";
import EditTeamIcon from "../components/icons/EditTeamIcon";
import { ThemeDefinitions, Themes } from "../theme";
export var HostFormVerticalSpace = 30;
var useStyles = createUseStyles(function (theme) { return ({
    host: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    content: {
        display: "flex",
        flexDirection: "row",
        flex: 1
    },
    panel: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: [20, 0]
    },
    container: {
        display: "flex",
        flexDirection: "column",
        width: 380,
    },
    lobbyForm: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        "& > *": {
            margin: [4, 0]
        },
    },
    actionButton: {
        display: "block",
        marginTop: HostFormVerticalSpace,
        width: 125,
    },
    separator: {
        height: 1,
        border: "1px dashed #707070",
        opacity: 0.3,
        marginTop: 20,
    },
    checkbox: {
        marginTop: HostFormVerticalSpace
    },
    textField: {
        marginTop: HostFormVerticalSpace
    },
    addTeams: {
        marginTop: HostFormVerticalSpace + 10,
        display: "flex",
    },
    addTeamsLabels: {
        display: "flex",
        flexDirection: "column",
        "& *": {
            marginBottom: 5
        }
    },
    teamButton: {
        background: "none",
        userSelect: "none",
        cursor: "pointer",
        width: 26,
        height: 26,
        marginRight: 20,
        padding: 0,
        border: "none",
        "&:focus": {
            outline: "none",
            "& svg": {
                fill: theme.color.secondary.main
            },
        },
    },
}); });
export var CreateState;
(function (CreateState) {
    CreateState[CreateState["main"] = 0] = "main";
    CreateState[CreateState["teams"] = 1] = "teams";
})(CreateState || (CreateState = {}));
var HostPage = function (props) {
    var _a, _b, _c;
    var theme = useTheme();
    var navigate = useNavigate();
    var _d = useContext(EngageContext), sendMessage = _d.sendMessage, lobby = _d.lobby, user = _d.user, clearError = _d.clearError, errorMap = _d.errorMap;
    var _e = useState(CreateState.main), createState = _e[0], setCreateState = _e[1];
    var classes = useStyles();
    var _f = useContext(ConfigContext), title = _f.title, teams = _f.teams;
    var CreateLobbyExtension = props.createLobbyExtension;
    var handleCreateInputChange = function (e) {
        var name = e.target.name;
        var value = getInputValue(e.target);
        setCreateFormValues(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[name] = value, _a)));
        });
        clearError(ErrorType.FailCreate);
    };
    var setFormValue = function (key, value) {
        setCreateFormValues(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[key] = value, _a)));
        });
        clearError(ErrorType.FailCreate);
    };
    var handleJoinInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setJoinFormValues(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[name] = value, _a)));
        });
        clearError(ErrorType.NoLobby);
    };
    var onCreate = function (e) {
        e.preventDefault();
        sendMessage(__assign({ type: EngageMessageType.CreateLobby }, createFormValues));
    };
    var onJoin = function (e) {
        e.preventDefault();
        sendMessage({
            type: EngageMessageType.JoinLobby,
            lobbyID: joinFormValues.joinCode,
            hostCode: joinFormValues.hostCode,
            nickname: AlternateHostName
        });
    };
    var handleAddTeams = function () {
        setCreateState(CreateState.teams);
    };
    var _g = useState({
        title: "",
        askForNickname: true,
        lobbyID: "",
        teamMode: TeamMode.Off,
        hostName: "",
        themeId: Themes.brand2025
    }), createFormValues = _g[0], setCreateFormValues = _g[1];
    var _h = useState({
        joinCode: "",
        hostCode: ""
    }), joinFormValues = _h[0], setJoinFormValues = _h[1];
    useEffect(function () {
        if (lobby && user) {
            navigate("/app");
        }
    }, [lobby, user]);
    var createError = errorMap ? errorMap[ErrorType.FailCreate] : undefined;
    var joinError = errorMap ? errorMap[ErrorType.NoLobby] : undefined;
    var currentThemeId = (_a = createFormValues.themeId) !== null && _a !== void 0 ? _a : Themes.brand2025;
    return (React.createElement("div", { className: classes.host },
        React.createElement(AppBar, { title: title }),
        createState === CreateState.main ?
            React.createElement("div", { className: classes.content },
                React.createElement("div", { className: classes.panel, style: { backgroundColor: theme.color.background.main } },
                    React.createElement("div", { className: classes.container },
                        React.createElement(DisplayText, { variant: TextVariant.s22reg, fontWeight: 400, color: "primary" }, "Create Lobby"),
                        React.createElement("form", { onSubmit: onCreate, className: classes.lobbyForm },
                            React.createElement(TextField, { labelText: "Lobby Name", name: "title", required: true, variant: "filled", value: createFormValues.title, onChange: handleCreateInputChange, className: classes.textField, errorColor: theme.host.create.errorColor, backgroundColor: "#D2DAE0", backgroundHoverColor: "#B4C1CB" }),
                            React.createElement(TextField, { labelText: "Lobby Code", name: "lobbyID", errorText: createError, variant: "filled", helperText: "Leave blank to generate a lobby code.", value: createFormValues.lobbyID, onChange: handleCreateInputChange, className: classes.textField, errorColor: theme.host.create.errorColor, backgroundColor: "#D2DAE0", backgroundHoverColor: "#B4C1CB" }),
                            React.createElement(TextField, { labelText: "Host Name", name: "hostName", errorText: createError, required: true, variant: "filled", helperText: "Fill in your full name so we can contact you if necessary. You can change the host display name on the next screen.", value: createFormValues.hostName, onChange: handleCreateInputChange, className: classes.textField, errorColor: theme.host.create.errorColor, backgroundColor: "#D2DAE0", backgroundHoverColor: "#B4C1CB" }),
                            CreateLobbyExtension &&
                                React.createElement(CreateLobbyExtension, { handleInputChange: handleCreateInputChange, formValues: createFormValues, separatorClass: classes.separator, setFormValue: setFormValue }),
                            teams &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: classes.addTeams },
                                        ((_b = createFormValues.teams) === null || _b === void 0 ? void 0 : _b.length) ?
                                            React.createElement("button", { onClick: handleAddTeams, className: classes.teamButton, type: "button" },
                                                React.createElement(EditTeamIcon, { color: theme.color.primary.main })) :
                                            React.createElement("button", { onClick: handleAddTeams, className: classes.teamButton, type: "button" },
                                                React.createElement(AddTeamIcon, { color: theme.color.primary.main })),
                                        React.createElement("div", { className: classes.addTeamsLabels },
                                            React.createElement(DisplayText, { variant: TextVariant.s18reg, component: "span" }, "Team Event"),
                                            React.createElement(DisplayText, { variant: TextVariant.s12reg, color: "#818181" }, ((_c = createFormValues.teams) === null || _c === void 0 ? void 0 : _c.length) ?
                                                "You have a team game with ".concat(createFormValues.teams.length, " teams!") :
                                                "Make this a team based trivia game!"))),
                                    React.createElement("div", { className: classes.separator })),
                            React.createElement(Checkbox, { name: "askForNickname", labelText: "Ask players for nickname", value: createFormValues.askForNickname, onChange: handleCreateInputChange, className: classes.checkbox }),
                            React.createElement("div", { className: classes.separator }),
                            React.createElement(Button, { className: classes.actionButton, type: "submit" }, "Create")))),
                React.createElement("div", { className: classes.panel, style: { backgroundColor: theme.color.background.lighter } },
                    React.createElement("div", { className: classes.container },
                        React.createElement(DisplayText, { variant: TextVariant.s22reg, fontWeight: 400, color: "primary" }, "Join Lobby as Host"),
                        React.createElement("form", { onSubmit: onJoin, className: classes.lobbyForm },
                            React.createElement(TextField, { labelText: "Lobby Code", name: "joinCode", required: true, variant: "filled", errorText: joinError && "Lobby or host code is incorrect.", value: joinFormValues.joinCode, onChange: handleJoinInputChange, className: classes.textField, backgroundColor: "#D2DAE0", backgroundHoverColor: "#B4C1CB" }),
                            React.createElement(TextField, { labelText: "Host Code", name: "hostCode", required: true, variant: "filled", errorText: joinError && "Lobby or host code is incorrect.", value: joinFormValues.hostCode, onChange: handleJoinInputChange, className: classes.textField, backgroundColor: "#D2DAE0", backgroundHoverColor: "#B4C1CB" }),
                            React.createElement(Button, { className: classes.actionButton, type: "submit" }, "Join"))))) :
            React.createElement(ThemeProvider, { theme: ThemeDefinitions[currentThemeId] },
                React.createElement(CreateTeams, { formValues: createFormValues, setFormValue: setFormValue, setState: setCreateState }))));
};
export default HostPage;
//# sourceMappingURL=host.js.map